<template lang='pug'>
  .powerful-platform
    //bottom-arch
    website-spacing.whitespace
      v-row(justify='center').whitespace
        .display-1.pa-4.grey--text.text--darken-2.text-center Focus on Your Automated Tests<br/>Not on Your Automated QA Testing Tools
      v-row.mt-10
        v-col(align='center' cols='12' sm='6')
          .text-center.mb-10.headline.font-weight-light.grey--text.text--darken-2 Realtime Dashboard
          video(autoplay loop muted width='100%' :class='{"video-left": !isMobile, "elevation-4": isMobile}')
            source(src='https://assets.bionicmetrics.com/bionic/demo.mp4')
      v-row.mt-10
        v-col(align='center' cols='12' sm='6' offset-sm='6')
          .text-center.mb-10.headline.font-weight-light.grey--text.text--darken-2 Video Captured of Every Test
          video(autoplay loop muted width='100%' :class='{"video-right": !isMobile, "elevation-4": isMobile}')
            source(src='https://assets.bionicmetrics.com/bionic/videoDemo.mp4')
      v-row.mt-10
        v-col(align='center' cols='12' sm='6')
          .text-center.mb-10.headline.font-weight-light.grey--text.text--darken-2 Run In Parallel and Run at any Scale
          video(autoplay loop muted width='100%' :class='{"video-left": !isMobile, "elevation-4": isMobile}')
            source(src='https://assets.bionicmetrics.com/bionic/parallelDemo.mp4')
      v-row.mt-10
        v-col(align='center' cols='12' sm='6' offset-sm='6')
          .text-center.mb-10.headline.font-weight-light.grey--text.text--darken-2 Quickly Diagnose Issues with Screenshots, Browser and Network Errors, Video and More
          video(autoplay loop muted width='100%' :class='{"video-right": !isMobile, "elevation-4": isMobile}')
            source(src='https://assets.bionicmetrics.com/bionic/debugDemo.mp4')
</template>

<script>
import BottomArch from './BottomArch';
import WebsiteSpacing from './WebsiteSpacing';

export default {
  name: 'PowerfulPlatform',
  components: {BottomArch, WebsiteSpacing},
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.mdAndDown;
    }
  },
  data() {
    return {};
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .powerful-platform {
    background-color: #ffffff;
    min-height: 100vh;
  }

  .video-max {
    max-width: 60vmin;
  }

  .video-right {
    position: relative;
    width: 30em;
    /*height: vw;*/
    transform: rotate3d(.5, -.866, 0, 15deg) rotateZ(1deg);
    box-shadow: 27.1px 62.5px 125px -25px rgba(50, 50, 93, .5), 16.2px 37.5px 75px -37.5px rgba(0, 0, 0, .6);
    background: #ffffff;
    display: flex;
    flex-direction: column;
  }

  .video-left {
    width: 30em;
    /*height: 40vw;*/
    position: relative;
    transform: rotate3d(.5, .866, 0, 15deg) rotateZ(-1deg);
    box-shadow: -27.1px 62.5px 125px -25px rgba(50, 50, 93, .5), -16.2px 37.5px 75px -37.5px rgba(0, 0, 0, .6);
    border-radius: 10px;
    background: #ffffff;
    display: flex;
    flex-direction: column;
  }

  .whitespace {
    margin-top: 10vh;
    margin-bottom: 10vh;
  }

  .details {
    background: #1DE9B6;
  }
</style>
